<template>
  <div class="privacy-main-div">
    <label class="vasion-page-subheader">Vasion Analytics</label>
      <div class="opt-in-switch-container">
        <div class="opt-in-switch">
          <md-switch v-model="isAnalyticsOptIn" @change="changeisAnalyticsOptOutSettings()"> 
            <span v-if="!isAnalyticsOptIn" class="text-muted">Opted out</span>
            <span v-if="isAnalyticsOptIn" class="text-muted">Opted in</span>
          </md-switch>
        </div>
      </div>
      <div class="opt-in-message">
        <span>For more information, please see our <a href="https://vasion.com/cookie-information/" target="_blank"><span>Cookie</span></a> and <a href="https://vasion.com/privacy-policy/" target="_blank"><span>Privacy</span></a> Policy.</span>

      </div>
  </div>
</template>

<script>

export default {
  name: 'PrivacyUserSettings',
  data: function () {
    return {
      isAnalyticsOptIn: true,      
    }
  },
  created: async function () {
    await this.$store.dispatch('admin/getUserSetting', 'IsAnalyticsOptOut')
    this.isAnalyticsOptIn = !(this.$store.state.admin.originalIsAnalyticsOptOut === "true")
  },  
  methods: {
    async changeisAnalyticsOptOutSettings() {
      this.$store.dispatch('admin/isAnalyticsOptOutSelection', !this.isAnalyticsOptIn)

      const response = await this.$store.dispatch('admin/setUserSetting', { settingName: 'IsAnalyticsOptOut', settingValue: !this.isAnalyticsOptIn})
        // eslint-disable-next-line
        const responseBool = response.status == 200
        this.showSnackbar = true
        this.snackbarTitle = responseBool ? 'Success' : 'Error'
        this.snackbarText = responseBool ? 'Settings saved' : 'Unable to save your preference.'
        this.snackbarImage = responseBool
      
      if (this.isAnalyticsOptIn) {
        const userId = this.$store.state.common.userID
        await this.$amplitude.checkAmplitudeAvailability()
        await this.$amplitude.identifyUser(userId > 0 ? `${window.location.host}:${userId}`: null)
      } else {
        await this.$amplitude.reset()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';

  .privacy-main-div {
    background-color: $white;
    border-radius: 4px;
    padding: 12px 17px;
    z-index: 1000;
    width: 100%;
  }

  .opt-in-switch{
    font-size: 16px;

  }

  .opt-in-message{
    font-size: 14px;
  }

  ::v-deep .md-switch.md-theme-default.md-checked .md-switch-thumb{
    background-color: $orange-300;
  }
</style>
